// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("@nathanvda/cocoon")
require("select2")

// https://stackoverflow.com/questions/55895494/is-not-defined-when-installing-jquery-in-rails-via-webpack
window.jQuery = $;
window.$ = $;

// https://gorails.com/forum/install-bootstrap-with-webpack-with-rails-6-beta
import "bootstrap"
import "@fortawesome/fontawesome-free/js/all"
import "../src/application.scss"

import "../src/google_analytics.js"
import "../src/fade.js"
import "highcharts"
import "highcharts/modules/pattern-fill.js"
import "highcharts-grouped-categories"

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "controllers"
